import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Store } from '@ngrx/store';
import {
    cancelPermPostOfferConfirmNotStartingModal,
    setJobOfferStatusToOfferAcceptedNotStartingConfirmed
} from 'src/app/root-store/perm-post-offer-workflow-store/actions';
import { PermPostOfferConfirmNotStartingModalPayload } from '../../../../root-store/perm-post-offer-workflow-store/models/perm-post-offer-confirm-not-starting.model';
import { AmSubmittalStatusUpdateCancelButtonComponent } from '../../components/am-submittal-status-update-cancel-button/am-submittal-status-update-cancel-button.component';
import { filter } from 'rxjs';
import * as permPostOfferCandidateWorkflowSelectors from '../../../../root-store/perm-post-offer-workflow-store/perm-post-offer-candidate-workflow.selectors';
import { MatButtonModule } from '@angular/material/button';
import { SendToClientInfoCardComponent } from '../send-to-client-modal/send-to-client-info-card/send-to-client-info-card.component';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { NgIf } from '@angular/common';

@UntilDestroy()
@Component({
    selector: 'nova-perm-post-offer-confirm-not-starting-modal',
    templateUrl: './perm-post-offer-confirm-not-starting-modal.component.html',
    styleUrls: ['./perm-post-offer-confirm-not-starting-modal.component.scss'],
    standalone: true,
    imports: [
        MatDialogModule,
        NgIf,
        MatProgressBarModule,
        MatIconModule,
        SendToClientInfoCardComponent,
        MatButtonModule,
        AmSubmittalStatusUpdateCancelButtonComponent
    ]
})
export class PermPostOfferConfirmNotStartingModalComponent implements OnInit {
    // Constants
    readonly labelFlex = '25';
    readonly dataFlex = '75';

    @ViewChild('cancelButton') cancelButton: AmSubmittalStatusUpdateCancelButtonComponent;

    viewModel: PermPostOfferConfirmNotStartingModalPayload;
    isSubmitting = false;

    constructor(
        @Inject(MAT_DIALOG_DATA) data: PermPostOfferConfirmNotStartingModalPayload,
        private readonly store: Store
    ) {
        this.viewModel = data;
    }

    ngOnInit() {
        this.store
            .select(permPostOfferCandidateWorkflowSelectors.selectPermPostOfferConfirmNotStartingModalIsSubmitting)
            .pipe(
                filter((r) => r !== undefined),
                untilDestroyed(this)
            )
            .subscribe((loadingResult) => {
                this.isSubmitting = loadingResult.isSubmitting;

                if (this.isSubmitting) {
                    this.cancelButton?.enable();
                }
            });
    }

    onSubmit(): void {
        const props = { jobOfferId: this.viewModel.permanentJobOfferId };

        this.cancelButton?.disable();

        this.store.dispatch(setJobOfferStatusToOfferAcceptedNotStartingConfirmed(props));
    }

    closeDialog(): void {
        this.store.dispatch(cancelPermPostOfferConfirmNotStartingModal());
    }
}
